import React, { ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import Joyride, { CallBackProps, ACTIONS, EVENTS, STATUS, LIFECYCLE, Step } from "react-joyride";

// JOYRIDE important objects and their variables:

// ACTIONS
// INIT: 'init',
// START: 'start',
// STOP: 'stop',
// RESET: 'reset',
// PREV: 'prev',
// NEXT: 'next',
// GO: 'go',
// CLOSE: 'close',
// SKIP: 'skip',
// UPDATE: 'update',

// POSIBLE EVENT
// TOUR_START: 'tour:start',
// STEP_BEFORE: 'step:before',
// BEACON: 'beacon',
// TOOLTIP: 'tooltip',
// STEP_AFTER: 'step:after',
// TOUR_END: 'tour:end',
// TOUR_STATUS: 'tour:status',
// TARGET_NOT_FOUND: 'error:target_not_found',
// ERROR: 'error',

// LIFECYCLE
// INIT: 'init',
// READY: 'ready',
// BEACON: 'beacon',
// TOOLTIP: 'tooltip',
// COMPLETE: 'complete',
// ERROR: 'error',

// STATUS
// IDLE: 'idle',
// READY: 'ready',
// WAITING: 'waiting',
// RUNNING: 'running',
// PAUSED: 'paused',
// SKIPPED: 'skipped',
// FINISHED: 'finished',
// ERROR: 'error',

export const useGuide = ( stepsValues = [], init = false ) => {
    
    const [steps, setSteps] = useState(stepsValues);
    const [run, setRun] = useState(init);
    const [stepIndex, setStepIndex] = useState(0);

    const handleJoyrideCallback = useCallback((dataCallBackProps) => {
        const { action, index, status, type } = dataCallBackProps;

        if (
            // If close button clicked then close the tour
            action === ACTIONS.CLOSE ||
            // If skipped or end tour, then close the tour
            (status === STATUS.SKIPPED && run) ||
            status === STATUS.FINISHED
            ) {
                setRun(false);
        } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
            // Check whether next or back button click and update the step
            setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
        }

        console.groupCollapsed(type);
        console.log(dataCallBackProps); //eslint-disable-line no-console
        console.groupEnd();
    }, []);

    const handleClickStart = (e) => {  
        
        e.preventDefault();
        e.stopPropagation();
        
        setRun(true);
        setStepIndex(0);

    };

    // const tour = useMemo(
    //     () => (
    //         <Joyride
    //             run={run}
    //             callback={handleJoyrideCallback}
    //             steps={steps}
    //             stepIndex={stepIndex}
    //             disableBeacon={false}
    //             disableScrollParentFix={true}
    //             disableOverlayClose={true}
    //             continuous={true}
    //             showProgress={true}
    //             showSkipButton={true}
    //             // scrollToSteps={true}
    //             styles={joyrideStyles}
    //         />
    //     ),
    //     [steps, handleClickStart, handleJoyrideCallback, run, setRun, stepIndex, setStepIndex]
    // );

    // return tour;
    return {steps, handleClickStart, handleJoyrideCallback, run, setRun, stepIndex, setStepIndex};
}
